import { defineStore } from 'pinia'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
const getModalArrayFieldName = isOuterModal => isOuterModal ? 'openedOuterModals' : 'openedModals'

export const useModalsStore = defineStore('modals', {
  state: () => ({
    openedModals: [],
    openedOuterModals: [],
    hiddenScrollElementList: new Set()
  }),
  getters: {
    openedModalsSet: (state) => new Set(state.openedModals),
    openedOuterModalsSet: (state) => new Set(state.openedOuterModals),
    lastModal (state) {
      return state.openedModals.at(-1)
    },
    lastOuterModal (state) {
      return state.openedOuterModals.at(-1)
    }
  },
  actions: {
    openModal (modal, isOuterModal = false) {
      const modalArrayFieldName = getModalArrayFieldName(isOuterModal)
      this[modalArrayFieldName].push(modal)
    },
    closeModal (closedModal, isOuterModal = false) {
      const modalArrayFieldName = getModalArrayFieldName(isOuterModal)
      const modalIndex = this[modalArrayFieldName].findIndex(modal => modal === closedModal)
      if (modalIndex === -1) return
      this[modalArrayFieldName].splice(modalIndex, 1)
    },
    disableBodyScroll (el, reserveScrollBarGap = true) {
      this.hiddenScrollElementList.add(el)
      if (this.hiddenScrollElementList.size > 1) return
      disableBodyScroll(el, {
        reserveScrollBarGap,
        allowTouchMove: el => {
          while (el && el !== document.body) {
            if (el.dataset.flBodyScrollLockIgnore) return true
            el = el.parentElement
          }
        }
      })
    },
    enableBodyScroll (el) {
      this.hiddenScrollElementList.delete(el)
      if (this.hiddenScrollElementList.size) return
      enableBodyScroll(el)
    }
  }
})
